import { Platform, Linking } from 'react-native';
import StaticSafeAreaInsets from 'react-native-static-safe-area-insets';
import DeviceInfo from 'react-native-device-info';

export const isWeb = Platform.OS === 'web';

export const isMacintosh = isWeb ? navigator.platform.indexOf('Mac') > -1 : false;

export let isPhone = !DeviceInfo.isTablet() && !isWeb;
export let isPhoneNative = isPhone && !isWeb;
export let isTabletOrWeb = !isPhone || isWeb;
export const isIOS = Platform.OS === 'ios';
export const platformVersion = parseInt(String(Platform.Version), 10);
export const isAndroid = Platform.OS === 'android';

export const updateIsPhone = (width: number) => {
  if (isWeb) {
    isPhone = width > 1080 ? false : true;
  }
};

export const { safeAreaInsetsBottom: safeBottom, safeAreaInsetsTop, safeAreaInsetsLeft, safeAreaInsetsRight } = StaticSafeAreaInsets || {};

export const safeAreaInsetsBottom = isIOS ? safeBottom : 0;

export const isIphoneX = isWeb ? false : safeAreaInsetsBottom > 0 || safeAreaInsetsTop > 0 || safeAreaInsetsLeft > 0 || safeAreaInsetsRight > 0;

export const xHeaderNormalizer = (value: number) => {
  if (isIphoneX && isPhone) {
    return value + 10;
  }
  return value;
};

export const textMargin = (v: number) => (isIOS ? 1.2 * v : v);

export const webScrollSupport = (
  ref: React.RefObject<{
    scrollTo: (...args: unknown[]) => void;
    getScrollResponder?: () => { scrollTo: (config: { y: number; animated: boolean }) => void };
  }>,
  y: number
) => {
  if (isWeb) {
    ref.current?.scrollTo(0, y);
  } else {
    ref.current?.getScrollResponder()?.scrollTo({ y: y, animated: false });
  }
};

export const KEYBOARD_AVOID_BEHAVIOR = isAndroid ? 'height' : 'padding';

export const handleOpenLink = (url: string) => {
  if (Platform.OS === 'web') {
    window.open(url, '_blank');
  } else {
    Linking.openURL(url);
  }
};
